// extracted by mini-css-extract-plugin
export default {"container":"Graphic_container__yqwRT"};